var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1E8BEA0-2FC5-4588-A9C0-619FF21F50B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-25.000000, -55.000000)",
    fill: "#457373",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-(9)",
    transform: "translate(25.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75,17.7777455 L1.25,17.7777455 C0.56000817,17.7777455 0,18.2755296 0,18.8888546 C0,19.5022159 0.56000817,20 1.25,20 L23.75,20 C24.4399918,20 25,19.5022159 25,18.8888183 C25,18.2755296 24.4399918,17.7777455 23.75,17.7777455 Z M1.25,2.22221819 L23.75,2.22221819 C24.4399918,2.22221819 25,1.72447036 25,1.11110909 C25,0.497747825 24.4399918,0 23.75,0 L1.25,0 C0.56000817,3.63107547e-05 0,0.497784136 0,1.1111454 C0,1.72447036 0.56000817,2.22221819 1.25,2.22221819 Z M23.75,8.88887275 L1.25,8.88887275 C0.56000817,8.88887275 0,9.38665689 0,10.0000182 C0,10.6133794 0.56000817,11.1111272 1.25,11.1111272 L23.75,11.1111272 C24.4399918,11.1111272 25,10.6133431 25,10.0000182 C25,9.3866932 24.4399918,8.88887275 23.75,8.88887275 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.08071d413fd0a93eea8748de6a972b01.svg";
export { ForwardRef as ReactComponent };